<template>
    <survey-loader v-if="loading" />
    <div v-else id="survey-finish">
        <survey-title class="text-center">{{ $t('generic.CLOSED_TITLE') }}</survey-title>

        <div class="text-center">
            <p class="text-width-70">
                <survey-icon class="mb-2" icon="warning" size="lg" color="accent" />
                <br />
                <span>{{ $t('generic.CLOSED_TEXT') }}</span>
            </p>
        </div>
    </div>
</template>
<script src="./SurveyClosed.ts"></script>
<style>
.text-width-70 {
    width: 70%;
    margin: 1rem auto;
}
</style>
